<template>
  <div v-if="category === 'page'">
    <page-index v-if="content === 'index'" :category="category"/>
    <page-content v-else :category="category" :limit="null" :content="content"/>
  </div>
  <div v-else-if="category === 'board'">
    <board-index v-if="content === 'index'" :category="category"/>
    <board-content v-else :category="category" :limit="null" :content="content"/>
  </div>
  <div v-else-if="category === 'game'">
    <game-index v-if="content === 'index'" :category="category"/>
    <game-content v-else :category="category" :limit="null" :content="content"/>
  </div>
  <div v-else-if="category === 'admin'">
    <admin-user v-if="content === 'user'" :category="category" :content="content"/>
    <e404 v-else />
  </div>
  <div v-else>
    <e404 />
  </div>
</template>
<script>
import PageIndex from '@/views/page/'
import PageContent from '@/views/page/content'
import BoardIndex from '@/views/board/'
import BoardContent from '@/views/board/content'
import GameIndex from '@/views/game/'
import GameContent from '@/views/game/content'
import AdminUser from '@/views/admin/user/'
import E404 from '@/views/e404'

export default {
  components: {
    PageIndex,
    PageContent,
    BoardIndex,
    BoardContent,
    GameIndex,
    GameContent,
    AdminUser,
    E404
  },
  data () {
    return {
      category: '',
      content: ''
    }
  },
  watch: {
    '$route.params' (n, o) {
      this.param2data(n)
    }
  },
  created () {
    this.param2data(this.$route.params)
  },
  destroyed () {
  },
  methods: {
    param2data (p) {
      this.category = p.category
      this.content = p.content
    }
  }
}
</script>
